var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_vm._v(" "),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"made-with-baserow",attrs:{"href":"https://baserow.io/","target":"_blank"}},[_vm._v("\n    Made with\n    "),_c('img',{attrs:{"src":require("@baserow_enterprise/assets/images/builder/mini_logo.svg"),"alt":"Baserow"}})])
}]

export { render, staticRenderFns }